import { useMemo } from 'react';
import Select from '../select';
import Input from '../Input';
import classNames from 'classnames';

export const DEFAULT_FILTER = { AV: null, AU: null, AY: null, AZ: null, BB: null };
function DiagnostikRecomendationsFilter({ onChange, filter }) {
  const selectedMaterialType = useMemo(() => {
    if (filter.AU) return MaterialTypes[1];
    else if (filter.AV) return MaterialTypes[2];
    return MaterialTypes[0];
  }, [filter.AU, filter.AV]);

  const selectedExecutionType = useMemo(() => {
    if (filter.BB === 2) return ExecutionTypes[1]; // Digital
    else if (filter.BB === 0) return ExecutionTypes[2]; // Paper-Pencil
    else if (filter.BB === 1) return ExecutionTypes[3]; // Digital und Paper-Pencil
    return ExecutionTypes[0]; // Alle
  }, [filter.BB]);

  const handleMaterialTypeChange = (option) => {
    const nextFilter = { ...filter, AU: 0, AV: 0 };
    if (option.field) {
      nextFilter[option.field] = 1;
    }
    onChange(nextFilter);
  };

  const handleExecutionTypeChange = (option) => {
    const nextFilter = { ...filter };
    nextFilter.BB = option.value;
    onChange(nextFilter);
  };

  const handleMaxInputChange = (evt) => {
    const nextFilter = { ...filter };
    evt.preventDefault();
    evt.stopPropagation();

    nextFilter[evt.target.name] = evt.target.value === '' ? null : Number(evt.target.value);

    onChange(nextFilter);
  };

  return (
    <div className="w-full sm:pt-12 lg:pt-24 space-y-2">
      <h3 className="text-lg font-bold text-black">Filteroptionen</h3>
      <div className={classNames('grid grid-cols-1 gap-4 xl:gap-16', !filter.AV && !filter.AU ? 'xl:grid-cols-4' : 'xl:grid-cols-3')}>
        <div>
          <Select label="Testsetting" selected={selectedMaterialType} setSelected={handleMaterialTypeChange} options={MaterialTypes} />
        </div>
        <div>
          <Select label="Digital oder Paper-Pencil" selected={selectedExecutionType} setSelected={handleExecutionTypeChange} options={ExecutionTypes} />
        </div>
        {!!((!filter.AV && !filter.AU) || filter.AU) && (
          <div>
            <Input
              type="number"
              name="AY"
              label="Bearbeitungszeit Einzeltestung"
              onChange={handleMaxInputChange}
              placeholder="maximal Minuten"
              min={0}
            />
          </div>
        )}
        {!!((!filter.AV && !filter.AU) || filter.AV) && (
          <div>
            <Input
              type="number"
              name="AZ"
              label="Bearbeitungszeit Gruppentestung"
              onChange={handleMaxInputChange}
              placeholder="maximal Minuten"
              min={0}
            />
          </div>
        )}
      </div>
    </div>
  );
}

const MaterialTypes = [
  { id: 0, field: null, name: 'Alle', description: 'Zeigt alle verfügbaren Elemente' },
  { id: 1, field: 'AU', name: 'Einzeltestung' },
  { id: 2, field: 'AV', name: 'Gruppentestung' },
];

const ExecutionTypes = [
  { id: 0, value: null, name: 'Alle', description: 'Zeigt alle verfügbaren Elemente' },
  { id: 1, value: 2, name: 'Digital', description: 'Nur digitale Verfahren' },
  { id: 2, value: 0, name: 'Paper-Pencil', description: 'Nur Paper-Pencil Verfahren' },
  { id: 3, value: 1, name: 'Digital und Paper-Pencil', description: 'Beide Verfahren verfügbar' },
];

export default DiagnostikRecomendationsFilter;
